import { Dialog, DialogContent, Typography, Box, Button, DialogTitle } from "@mui/material";

const DeleteConfirmationModal = ({ openDialog, closeDialog, title, message, onConfirm }) => {
  return (
    <Dialog open={openDialog} onClose={closeDialog}>

      <DialogTitle variant="h6" color='error'>{title}</DialogTitle>

      <DialogContent sx={{ minWidth: "30rem" }}>


        <Typography variant="body2" color='text.secondary'>{message}</Typography>

        <Box sx={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
          <Button onClick={onConfirm} variant="contained" color="error">Delete</Button>
          <Button variant="outlined" onClick={closeDialog} sx={{ marginLeft: "20px" }}>CANCEL</Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteConfirmationModal
